$( document ).ready(function() {

  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });

  window.addEventListener("pageshow", function() {
    $("body").removeClass("fade-out");
  }, false);

  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 1000);

  // LAZY LOAD
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            l.src = l.dataset.src;
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // SLIDE IN EFFECT
  function checkElementLocation() {
    var $window = $(window);
    var bottom_of_window = $window.scrollTop() + $window.height();
    var currentScroll = $(window).scrollTop();
    $('.toslide').each(function(i) {
      var $that = $(this);
      var bottom_of_object = $that.position().top + $that.outerHeight() - $window.height() + 300;
      var trozoqueseve = $that.position().top - currentScroll - $window.height()
      if (trozoqueseve < -100) {
        $(this).addClass('slide-in');
      }
    });
  }
  checkElementLocation();
  $(window).on('scroll', function() {
    checkElementLocation();
  });


  // HIDE SHOW MENU
  $( window ).scroll(function() {
  	var scroll = $(window).scrollTop();
  	if(scroll >= 25){
  		$("header").addClass("hidedat");
        $("#logo-menu").addClass("goup");
  	} else {
  		$("header").removeClass("hidedat");
        $("#logo-menu").removeClass("goup");
  	}
  });
  var currentMousePos = { y: -1 };
  $(document).mousemove(function(event) {
    currentMousePos.y = event.pageY;
    var scroll = $(window).scrollTop();
    var finalmierda = currentMousePos.y - scroll
    if (finalmierda < 150) {
      $("header").addClass("supersupershowdat");
      $("#logo-menu").addClass("supergodown");
    } else {
      $("header").removeClass("supersupershowdat");
      $("#logo-menu").removeClass("supergodown");
    }
  });
  function detectMouseWheelDirection( e )
  {
      var delta = null,
          direction = false
      ;
      if ( !e ) { // if the event is not provided, we get it from the window object
          e = window.event;
      }
      if ( e.wheelDelta ) { // will work in most cases
          delta = e.wheelDelta / 60;
      } else if ( e.detail ) { // fallback for Firefox
          delta = -e.detail / 2;
      }
      if ( delta !== null ) {
          direction = delta > 0 ? 'up' : 'down';
      }
      return direction;
  }
  function handleMouseWheelDirection( direction )
  {
      if ( direction == 'down' ) {
          $("header").removeClass("supershowdat");
          $("#logo-menu").removeClass("supergodown");
      } else if ( direction == 'up' ) {
          $("header").addClass("supershowdat");
          $("#logo-menu").addClass("supergodown");
      } else {
      }
  }
  document.onmousewheel = function( e ) {
      handleMouseWheelDirection( detectMouseWheelDirection( e ) );
  };

  // PRESS
  (function () {
  const $container = $("#press-image-container");
  if (!$container.length) return;

  // This is the image injected by your "default image" section
  const $img = $container.find("#press-image-default").first();
  if (!$img.length) return;

  // Cache default values once
  const defaultSrc = $img.attr("data-default-src") || $img.attr("src") || "";
  const defaultSrcset = $img.attr("data-default-srcset") || $img.attr("srcset") || "";
  const defaultSizes = $img.attr("data-default-sizes") || $img.attr("sizes") || "";

  // Persist cache on the element (helps if scripts run more than once)
  if (defaultSrc) $img.attr("data-default-src", defaultSrc);
  if (defaultSrcset) $img.attr("data-default-srcset", defaultSrcset);
  if (defaultSizes) $img.attr("data-default-sizes", defaultSizes);

  // Delegated events so it works even if .press items are rendered later
  $(document)
    .off(".pressSwap")
    .on("mouseenter.pressSwap focusin.pressSwap", ".press", function () {
      const hoverSrc = $(this).attr("data-img");
      if (!hoverSrc) return;

      // Swap to hover image
      $img.attr("src", hoverSrc);

      // IMPORTANT: prevent the default image srcset being used for hover
      $img.removeAttr("srcset");
      // keep sizes (optional)
    })
    .on("mouseleave.pressSwap focusout.pressSwap", ".press", function () {
      // Revert to default
      if (defaultSrc) $img.attr("src", defaultSrc);

      // Restore responsive attributes if they existed
      if (defaultSrcset) $img.attr("srcset", defaultSrcset);
      if (defaultSizes) $img.attr("sizes", defaultSizes);
    });
})();


  
  // PODCAST MENU
  $( "#podcast-menu a" ).hover(
    function() {
      $(this).next(".submenu").addClass("show");
    }, function() {
      $(this).next(".submenu").removeClass("show");
    }
  );
  $( ".submenu" ).hover(
    function() {
      $(this).addClass("show");
    }, function() {
      $(this).removeClass("show");
    }
  );

  // MOBILE MENU
  $( "#burger" ).click(function() {
    $(this).toggleClass("close");
    $("#menu-mobile").slideToggle();
  });

  // NEWSLETTER

  if (Cookies.get('Subed')){
  } else {
    setTimeout(function(){
      $("#subscribe-form").fadeIn();
    }, 5000);
  }
  $( "#close-news" ).click(function() {
    $("#subscribe-form").fadeOut();
    Cookies.set('Subed', '1');
  });
  $( ".newsletter-trigger" ).click(function() {
    $("#subscribe-form").fadeIn();
  });

  // MEDITATION 
  $( ".med-day-click" ).click(function() {
    var link = $(this).attr('data-link')
    var target = $(this).attr('data-target')
    if(target == "_blank"){
      window.open(link);
    } else {
      window.location.href = link
    }    
  });
  
  // MEDITATION MOBILE
  $( ".med-day img" ).click(function() {
    $(".med-day-hover").removeClass("active");
    $(this).parent().children(".med-day-hover").addClass("active");
  });
  
  // MEDITATION MOBILE
  $( "#subscribe-trigger" ).click(function() {
    $("#subscribe-form").fadeIn();
  });


  
  
});